import React, { useReducer, useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import useDebounce from '../../../utils/useDebounce';
import {
  reducerInitialState, reducer, updateSearch, handleClick, handleDelete, obtainFormOutput, toggleDeleteInfoScreen, updateSearchTerm, loadPage,
} from './artistSupportingFunctions';


import Filter from '../../Tabs/Filter';
import LoadIcon from '../../LoadIcon';
import DataTable from '../../Table/DataTable';
import artistSetColumns from './artistSetColumns';

import ArtistForm from './ArtistForm';
import Form from './Form';
import Modal from '../../Modal/Modal';


const ArtistContainer = ({ history }) => {
  const [state, dispatch] = useReducer(reducer, reducerInitialState);

  const debouncedSearchTerm = useDebounce(state.filterText, 500);

  // The table owns page size and sort order; both reset to the first page,
  // because a different page size or order makes the old offset meaningless.
  const setRowsPerPage = (next) => {
    dispatch({ type: 'manageRowsPerPage', rowsPerPage: next });
    loadPage(state.filterText, 0, dispatch, next, state.sorting);
  };

  const setSorting = (next) => {
    dispatch({ type: 'manageSorting', sorting: next });
    loadPage(state.filterText, 0, dispatch, state.rowsPerPage, next);
  };

  useEffect(() => {
    updateSearch(debouncedSearchTerm, dispatch);
  }, [debouncedSearchTerm]);

  const {
    filterText, isCreateModalOn, isDisplayModalOn, isDeleteModalOn, isModifyModalOn, currItemData, canItemBeDeleted, isDeleteInfoScreenOpen, filteredItems, isLoading, page, total, rowsPerPage, sorting,
  } = state;

  return (
    <div className="w-full bg-white">
      <div className="flex justify-between mb-4">
        <span className="text-americaMonoBold text-26">Artist Sets</span>
        <button
          type="button"
          className="font-americaMonoBold text-xs pr-6 pl-8 py-2 rounded-full bg-black text-white uppercase h-10 flex items-center"
          onClick={() => {
            handleClick('create', '', dispatch, filteredItems);
          }}
        >
          Create Artist Set
          {' '}
          <span className="font-icon icon-add-button text-white font-black pl-3 text-base" />
        </button>
      </div>
      {(isCreateModalOn) && (
      <Modal title="Add Artist Set" handleClick={(action, item = '') => handleClick(action, item, dispatch, filteredItems)} type="create">
        <Form saveForm={(output, action) => obtainFormOutput(output, action, history, filterText, dispatch)} formInput={currItemData[0]} handleClick={(action, item = '') => handleClick(action, item, dispatch, filteredItems)} />
      </Modal>
      )}
      {(isModifyModalOn) && (
      <Modal title="Modify Artist Set" handleClick={(action, item = '') => handleClick(action, item, dispatch, filteredItems)} type="modify">
        <Form saveForm={(output, action) => obtainFormOutput(output, action, history, filterText, dispatch)} formInput={currItemData[0]} handleClick={(action, item = '') => handleClick(action, item, dispatch, filteredItems)} />
      </Modal>
      )}
      {isDeleteModalOn && (
      <Modal title="Delete Artist Set" handleClick={(action, item = '') => handleClick(action, item, dispatch, filteredItems)} type="delete">
        <ArtistForm handleClick={(action, item = '') => handleClick(action, item, dispatch, filteredItems)} formInput={currItemData[0]} handleDelete={(itemId, itemSlug) => handleDelete(itemId, itemSlug, history, filterText, dispatch)} canItemBeDeleted={canItemBeDeleted} isDeleteInfoScreenOpen={isDeleteInfoScreenOpen} action="delete" closeToggleDelete={() => toggleDeleteInfoScreen(dispatch)} />
      </Modal>
      )}
      <div className="mt-4">
        <Filter updateSearch={val => updateSearchTerm(val, dispatch)} searchText={filterText} placeholder="Search artist sets by name or slug" />
        {isLoading && <LoadIcon />}
        {!isLoading && (filteredItems && filteredItems.length
          ? (
            <DataTable
              tableData={filteredItems}
              columns={artistSetColumns((action, item = '') => handleClick(action, item, dispatch, filteredItems))}
              total={total}
              page={page}
              setPage={newPage => loadPage(filterText, newPage, dispatch, rowsPerPage, sorting)}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              sorting={sorting}
              setSorting={setSorting}
            />
          )
          : <div>{filterText ? 'No artist sets match that search' : 'No artist sets yet'}</div>)}
      </div>
    </div>
  );
};

ArtistContainer.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(ArtistContainer);
